import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(
  {
    mainHeader: {
      color: '#2546AE',
      //fontWeight: 'bold',
      fontFamily: 'work sans',
      fontWeight: 500,
      fontSize: 18,
    },
    reset: {
      fontFamily: 'work sans',
      color: 'green',
      fontSize: 15,
      marginTop: 10
    },
    clearButton: {
      fontFamily: "Work Sans",
      fontStyle: "normal",
      fontWeight: "bold",
      textTransform: "capitalize",
      fontSize: 12,
      color: "#8392AB",
      border: "0.791301px solid #8392AB",
      background: "#F5F5F5",
      padding: "6px 20px",
      borderRadius: "4.7478px",
      marginLeft: 10,
      marginTop: 5,
    },
    searchButton: {
      marginTop: 5,
      marginRight: 12,
      background: " #3A416F",
      border: "0.791301px solid #3A416F",
      color: "#FFFFFF",
      fontFamily: "Work Sans",
      fontStyle: "normal",
      fontWeight: "bold",
      textTransform: "capitalize",
      fontSize: 12,
      padding: "5px 20px",
      borderRadius: "4.7478px",
      "&:hover": {
        color: "#FFFFFF",
        background: " #3A416F",
      },
    },
    error: {
      margin: '0',
      fontSize: ' 0.7rem',
      color: 'red',
      marginLeft: '13px'
    },
    email: {
      fontFamily: 'work sans',
      fontSize: 16,
      marginBottom: 6,
    },
    divFlex: {
      display: 'flex',
      alignItems: 'center',
      marginTop: -10,
    },
    emailText: {
      marginLeft: 12,
      width: '100%'
    },
    buttons: {
      textAlign: 'center',
      marginTop: 20,

    },
    submitButton: {
      marginLeft: 40,
      background: 'linear-gradient(#273da6,#1b90f1)',
      color: ' #fff',
      fontSize: 12,
      padding: '4px 10px',
      width: '25%'
    },
    backbutton: {
      background: '#EFEFEF',
      color: '#2196f3',
      fontSize: 12,
      padding: '4px 10px',
       width: '25%',
      marginLeft: 10,
    }
  })